import React, { useEffect, useState, useRef } from 'react';
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { isAdminRole, statusOptions } from '../../../utils/mics';
import appActions from '../../../appActions';
import { InputText } from 'primereact/inputtext';
import { AutoComplete } from "primereact/autocomplete";
import ExportExcel from '../../../components/ExportExcel';
import ImportExcel from '../../../components/ImportExcel';
const TaskNotificationFilterBar = (props) => {

    const dispatch = useDispatch();

    const taskNotification = useSelector((state) => state.tasknotification.taskNotificationDetails);

    const taskNotificationList = useSelector((state) => state.tasknotification.taskNotificationList);

    // Get site options from Redux store
    const storeOtions = useSelector((state) => state.common.storeList);

    const { userInfo } = props;
    const { userRole } = userInfo;

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (taskNotification?.id) {
            setVisible(false);
            dispatch(appActions.TASKNOTIFICATION_RESET_SUCCESS());
        }
    }, [taskNotification]);

    const formik = useFormik({
        initialValues: {
            title: '',
            siteId:''
        },
        enableReinitialize: true,
        onSubmit: (values) => {
            const data = {
                ...values,
            };
            const params = data;
            Object.keys(params).forEach((key) => {
                if (params[key] === '') {
                    delete params[key];
                }
            });
            props.handleFilter(params);
        },
    });

    const handleReset = () => {
        formik.resetForm();
    };

    const isEmpty = (obj) => {
        return Object.keys(obj).length === 0;
    };

    return (
        <>

            <div className="flex mb-4 align-items-end">
                <form onSubmit={formik.handleSubmit}>
                    <div className="flex flex-wrap align-items-end gap-10 pb-0">
                        {/* Form Fields */}

                        <div className="form-group">
                            <label htmlFor="title" className="flex align-items-center"> Subject </label>
                            <InputText
                                className="w-full"
                                id="title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                placeholder="Subject"
                            />
                        </div>

                        <div className="form-group">
                            <label htmlFor="siteName" className="flex align-items-center"> Site Name </label>
                            {/* <InputText
                                className="w-full"
                                id="siteName"
                                value={formik.values.siteName}
                                onChange={formik.handleChange}
                                placeholder="Site Name"
                            /> */}
                            <Dropdown
                                className="w-full"
                                id="siteId"
                                value={formik.values.siteId}
                                options={storeOtions}
                                optionLabel="label"
                                optionValue='siteId'
                                onChange={(e) => formik.setFieldValue('siteId', e.value)}
                                placeholder="Site Name"
                            />
                        </div>

                        {/* Buttons */}
                        <Button
                            type="submit"
                            icon="pi pi-search"
                            severity="basic"
                        />
                        {!isEmpty(props.filterParams) && (
                            <Button
                                onClick={handleReset}
                                icon="pi pi-times"
                                severity="secondary"
                                aria-label="Cancel"
                            />
                        )}
                    </div>
                </form>
                {isAdminRole(userRole) && (
                    <div className='flex justify-content-end ml-auto gap-10' style={{ minWidth: '200px' }}>

                        <ExportExcel fileName={'task_notification_report'} rowData={taskNotificationList?.data} /> 

                        {/* <ImportExcel url={'tasknotification/uploadFile'}
                                    handleSearch={props.handleSearch}/> */}

                        {/* <Button
                            icon="pi pi-plus"
                            label="Add"
                            severity="basic"
                            onClick={() => setVisible(true)}
                        /> */}
                    </div>
                )}
            </div>
        </>
    );
};

export default TaskNotificationFilterBar;
